<template>
  <div>
    <div class="text-banner text-center">
      <h2><strong>You are successfully logged out!</strong></h2>
    </div>
  </div>
</template>

<script>
  export default {}
</script>